// src/config/firebase.js
//
// 🟢 Single Firebase entry point for the whole web client. The mobile app and web
// share ONE Firebase project (allo-c4cd5), so the web client reads/writes the exact
// same Firestore documents — that's what makes cross-device E2EE interoperate.
//
// NOTE: the apiKey / appId / messagingSenderId belong in a .env (REACT_APP_*) and
// are injected at build time. The values here fall back to the existing project so
// the app keeps working; move them to .env.local before shipping publicly.

import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database';

// Env vars win in production; the project defaults let the dev server run out of the box.
// (These are the same public web-app config values already in the old firebaseConfig.js —
// Firebase web API keys are not secrets; security is enforced by Firestore rules.)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyCkkhXt2GhDEluEZzG5hcvVSe2czqRp52w',
  authDomain: 'allo-c4cd5.firebaseapp.com',
  projectId: 'allo-c4cd5',
  storageBucket: 'allo-c4cd5.firebasestorage.app',
  databaseURL: 'https://allo-c4cd5-default-rtdb.firebaseio.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID || '397203671414',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:397203671414:web:20a577a23165f13b2d5257',
};

const app = initializeApp(firebaseConfig);

/* 🟢 same switch as the app (config/firebase.ts): an `undefined` field is dropped
   instead of refusing the whole write with `invalid-argument`. */
export const db = initializeFirestore(app, { ignoreUndefinedProperties: true });
export const auth = getAuth(app);
export const storage = getStorage(app);
export const rtdb = getDatabase(app);
export default app;
